import { Button, Input, Space, Table } from "antd";
import React, { useRef, useState } from "react";
import { SearchOutlined } from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import Style from "./UserSupportTable.module.scss";
import moment from "moment-jalaali";

const UserSupportTable = ({ showModal, data }) => {
  const searchInput = useRef(null);
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const getColumnSearchProps = (dataIndex, title) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`جستجو ${title}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            جستجو
          </Button>
          <Button
            onClick={() => handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            پاکسازی
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };
  const columns = [
    {
      title: "شناسه پیام",
      dataIndex: "id",
      key: "id",
      ...getColumnSearchProps("id", "شناسه پیام"),
    },
    {
      title: "وضعیت پیام",
      dataIndex: "status",
      key: "status",
      ...getColumnSearchProps("status", "وضعیت پیام"),
      render: (text, record) => (
        <p>
          {record.status === "0"
            ? "جدید"
            : record.status === "1"
            ? "درحال بررسی"
            : "خاتمه یافته"}
        </p>
      ),
    },
    {
      title: "شناسه کاربر",
      dataIndex: "user_id",
      key: "user_id",
      ...getColumnSearchProps("user_id", "شناسه مشتری"),
      render: (text, record) => (
        <p style={{ cursor: "pointer" }} onClick={() => showModal(4, record)}>
          {text}
        </p>
      ),
    },
    {
      title: "نام کاربر",
      dataIndex: "name",
      key: "name",
      ...getColumnSearchProps("name", "اسم مشتری"),
      render: (text, record) => (
        <p style={{ cursor: "pointer" }} onClick={() => showModal(4, record)}>
          {text}
        </p>
      ),
    },
    {
      title: "شماره سفارش",
      dataIndex: "order_id",
      key: "order_id",
      ...getColumnSearchProps("order_id", "شماره سفارش"),
    },
    {
      title: "تاریخ",
      dataIndex: "date",
      key: "date",
      render: (text, record) =>
        moment.unix(parseInt(text)).format("jYYYY/jM/jD--HH:mm"),
    },
    {
      title: "عنوان",
      dataIndex: "title",
      key: "title",
    },
    {
      title: "امتیاز کاربر",
      dataIndex: "score",
      key: "score",
      render: (text, record) => <p>{text ? text : "ثبت نشده"}</p>,
    },
    {
      title: "عملیات",
      dataIndex: "orderBtn",
      key: "orderBtn",
      width: "16%",
      render: (text, record) => (
        <div className={Style.btnHolder}>
          <button
            onClick={() => showModal(2, record)}
            className={Style.orderBtn}
          >
            نمایش پیام
          </button>
          {record.status !== "2" ? (
            <button
              onClick={() => showModal(1, record)}
              className={Style.mapBtn}
            >
              اتمام
            </button>
          ) : null}
          {record.feedback && (
            <button
              onClick={() => showModal(3, record)}
              className={Style.feedback}
            >
              {" "}
              بازخورد
            </button>
          )}
        </div>
      ),
    },
  ];
  return (
    <div style={{ width: "100%" }}>
      <Table
        pagination={{ pageSize: 5 }}
        columns={columns}
        dataSource={data}
        responsive={true}
        scroll={{ x: 1100, y: 300 }}
      />
    </div>
  );
};

export default UserSupportTable;
